import React from 'react'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'

import { KeyboardArrowLeft } from '@material-ui/icons'
import { makeStyles, CircularProgress } from '@material-ui/core'
import Button from '../components/button/Button'
import UserAvatar from '../components/shared/UserAvatar'
import {
  getClassroomChildren,
  getChildrenRSPA
} from '../store/classrooms/actions'
import {
  tagsCounterByChildRSPA,
  getReportStudentsAnswers,
  cleanReportStudentAnswers,
  getStudentAnswersMetaRSPA,
  getReportStudents,
  cleanReportStudents
} from '../store/reports/actions'
import StyledSVG from '../components/shared/StyledSVG'
import filterFallbackSVG from '../assets/icons/report-student-filter-fallback.svg'
import ReportStudentFilterForm from '../components/form/ReportStudentFilterForm'
import { allPropsBlank } from '../utils/helpers'
import Pagination from '@material-ui/lab/Pagination'
import ReportStudentDetailView from '../components/view/ReportStudentDetailView'

const useStyles = makeStyles(theme => ({
  child_section_root: {
    display: 'flex',
    align: 'center',
    flexWrap: 'wrap',
    gap: 8,
    [theme.breakpoints.down(750)]: {
      justifyContent: 'center'
    }
  },
  root: {
    marginTop: 42,
    width: '97%',
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    [theme.breakpoints.down(750)]: {
      backgroundColor: 'unset'
    }
  },
  header: {
    padding: '36px 36px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  introdution_wrapper: {
    '& p,h1': {
      margin: 0
    },
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    [theme.breakpoints.down(750)]: {
      width: '100%',
      alignItems: 'center',
      textAlign: 'center'
    }
  },
  title_wrapper: {
    [theme.breakpoints.down(750)]: {
      width: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      position: 'relative'
    }
  },
  title: {
    color: '#4D5E80',
    fontSize: 32,
    fontWeight: 700,
    [theme.breakpoints.down(750)]: {
      fontSize: 24
    }
  },
  description: {
    fontSize: 14,
    [theme.breakpoints.down('1350')]: {
      maxWidth: 500
    },
    [theme.breakpoints.down('1000')]: {
      maxWidth: 350
    },
    [theme.breakpoints.down(750)]: {
      fontSize: 12
    }
  },
  go_back_btn: {
    backgroundColor: '#F4A87C',
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#F4A87C'
    },
    fontSize: '16px',
    fontWeight: 700,
    textTransform: 'capitalize',
    lineHeight: '100%',
    height: '100%',
    width: '100%'
  },
  btn_wrapper: {
    width: 144,
    height: 48,
    [theme.breakpoints.down('750')]: {
      display: 'none'
    }
  },
  button_root: {
    width: '100%',
    height: '100%'
  },
  filter_section: {
    padding: '0px 36px'
  },
  main: {
    padding: '36px 36px'
  },
  without_filter_fallback: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
    gap: 18,
    '& h1': {
      margin: 0,
      color: '#386093',
      fontSize: 24,
      fontWeight: 700,
      maxWidth: 580
    },
    '& p': {
      margin: 0,
      color: '#555555',
      fontSize: 16,
      fontWeight: 400,
      maxWidth: 560
    },
    [theme.breakpoints.down('820')]: {
      '& svg': {
        width: 350,
        height: 250,
        minWidth: 350,
        minHeight: 250
      }
    },
    [theme.breakpoints.down('440')]: {
      '& svg': {
        display: 'none'
      }
    }
  },
  horizontal_bar: {
    display: 'flex',
    justifyContent: 'center',
    height: 1,
    borderBottom: '1px #ADB8CC solid',
    margin: '30px 0px'
  },
  search_component: {
    marginTop: '8px',
    marginBottom: '12px',
    padding: '8px 12px',
    borderRadius: 8,
    border: '1px solid #D2D5D8',
    '& input': {
      padding: 0
    }
  },
  child_item: {
    width: 300,
    height: 80,
    borderRadius: 16,
    backgroundColor: '#F5F6F7',
    display: 'flex',
    justifyContent: 'flex-start',
    paddingLeft: 32,
    cursor: 'pointer',
    [theme.breakpoints.down(750)]: {
      backgroundColor: '#FFFFFF'
    }
  },
  pagination: {
    float: 'right',
    paddingTop: '15px',
    [theme.breakpoints.down('426')]: {
      float: 'unset',
      '& .MuiPagination-ul': {
        flexWrap: 'nowrap'
      }
    }
  },
  go_back_btn_arrow: {
    fontSize: 30,
    position: 'absolute',
    left: '-25px',
    '& path': {
      fill: '#386093'
    },
    [theme.breakpoints.up('750')]: {
      display: 'none'
    }
  }
}))

const ChildrensResult = ({
  classes,
  childrens,
  setPage,
  page,
  getChildrensFunction,
  setChildrenFetching,
  setSelectedChild,
  selectedChild,
  setFilterValues,
  filterValues,
  ...props
}) => {
  const handleChangePage = (event, value) => {
    setPage(value)
    setChildrenFetching(true)
    getChildrensFunction(value)
  }

  const handleClickItem = childId => {
    setSelectedChild(childId)
    setFilterValues({})
  }

  if (childrens.isFetching) {
    return <CircularProgress />
  } else if (selectedChild && allPropsBlank(filterValues)) {
    return <ReportStudentDetailView childId={selectedChild} {...props} />
  } else {
    return (
      <div className={classes.child_section_wrapper}>
        <div className={classes.child_section_root}>
          {childrens.items?.length > 0 ? (
            childrens.items.map(child => {
              return (
                <div
                  key={child.id}
                  onClick={() => handleClickItem(child.id)}
                  className={classes.child_item}
                >
                  <UserAvatar
                    avatarStyle={{ width: 40, height: 40 }}
                    avatarUrl={child.attributes?.avatar_url}
                    userName={child.attributes?.name}
                  />
                </div>
              )
            })
          ) : (
            <>Sem resultados para esse(s) filtro(s).</>
          )}
        </div>
        <div className={classes.child_pagination_wrapper}>
          {childrens.meta &&
            childrens.meta.page_count > 1 && (
              <Pagination
                count={childrens.meta.page_count}
                className={classes.pagination}
                color='primary'
                page={page}
                onChange={handleChangePage}
              />
            )}
        </div>
      </div>
    )
  }
}

const ChildrensDisplayPage = ({ getChildrenRSPA, ...props }) => {
  const classes = useStyles()
  const history = useHistory()
  const [filterValues, setFilterValues] = React.useState({})
  const [page, setPage] = React.useState(1)
  const [childrens, setChildrens] = React.useState({
    items: [],
    isFetching: false,
    meta: {}
  })
  const [selectedChild, setSelectedChild] = React.useState(null)

  const goBack = () => {
    history.goBack()
  }

  const getChildrensFunction = async page => {
    const options = ['grade_id', 'classroom_id', 'child_name']
    const queryOption = options.reduce(
      (acc, current) => ({
        ...acc,
        ...(filterValues?.[current]
          ? { [current]: filterValues?.[current] }
          : {})
      }),
      {}
    )
    if (!allPropsBlank(queryOption)) {
      await getChildrenRSPA({ ...queryOption, page }).then(res => {
        setChildrens(prev => ({
          items: res.data.data,
          isFetching: false,
          meta: res.data.meta
        }))
      })
    }
  }

  React.useEffect(
    () => {
      getChildrensFunction(1)
    },
    [
      filterValues?.grade_id,
      filterValues?.classroom_id,
      filterValues?.child_name
    ]
  )

  const setChildrenFetching = isFetching => {
    setChildrens(prev => ({ ...prev, isFetching: isFetching }))
  }

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <div className={classes.introdution_wrapper}>
          <div className={classes.title_wrapper}>
            <KeyboardArrowLeft className={classes.go_back_btn_arrow} />
            <h1 className={classes.title}>Detalhamento aluno</h1>
          </div>
          <p className={classes.description}>
            Aqui você encontra todos os detalhes da rotina do aluno nos diários
            de turma: frequência, observações, comprtamento e muito mais.
          </p>
        </div>
        <div className={classes.btn_wrapper}>
          <Button
            id='export'
            type='button'
            rootClass={classes.button_root}
            className={classes.go_back_btn}
            onClick={() => goBack()}
          >
            Voltar
          </Button>
        </div>
      </div>
      <div className={classes.filter_section}>
        <ReportStudentFilterForm
          setChildrenFetching={setChildrenFetching}
          setFilterValues={setFilterValues}
          filterValues={filterValues}
          setSelectedChild={setSelectedChild}
        />
        <div className={classes.horizontal_bar} />
      </div>
      <div className={classes.main}>
        {allPropsBlank(filterValues) && !selectedChild ? (
          <div className={classes.without_filter_fallback}>
            <StyledSVG width={550} height={380} src={filterFallbackSVG} />
            <h1>Use os filtros para começar sua busca.</h1>
            <p>
              Preencha os filtros acima para localizar e acompanhar o histórico
              completo do aluno desejado
            </p>
          </div>
        ) : (
          <ChildrensResult
            page={page}
            setPage={setPage}
            childrens={childrens}
            setChildrens={setChildrens}
            classes={classes}
            setChildrenFetching={setChildrenFetching}
            getChildrensFunction={getChildrensFunction}
            setFilterValues={setFilterValues}
            filterValues={filterValues}
            history={history}
            selectedChild={selectedChild}
            setSelectedChild={setSelectedChild}
            {...props}
          />
        )}
      </div>
    </div>
  )
}

const mapStateToProps = (state, props) => {
  const { classrooms, reports } = state
  return {
    currentChild: classrooms?.currentChild,
    reportAnswers: reports?.reportAnswers,
    reportStudentsPerDate: reports?.reportStudents
  }
}

const mapDispatchToProps = dispatch => ({
  getChildrenRSPA: data => dispatch(getChildrenRSPA.request(data)),
  getReportStudents: data => dispatch(getReportStudents(data)),
  getClassroomChildren: data => dispatch(getClassroomChildren(data)),
  getStudentAnswersMetaRSPA: data =>
    dispatch(getStudentAnswersMetaRSPA.request(data)),
  tagsCounterByChildRSPA: data =>
    dispatch(tagsCounterByChildRSPA.request(data)),
  getReportStudentsAnswers: data => dispatch(getReportStudentsAnswers(data)),
  cleanReportStudentAnswers: data => dispatch(cleanReportStudentAnswers(data)),
  cleanReportStudents: data => dispatch(cleanReportStudents(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(
  ChildrensDisplayPage
)
